import { render } from "./ProductReport.vue?vue&type=template&id=aa68d05e"
import script from "./ProductReport.vue?vue&type=script&lang=js"
export * from "./ProductReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__